import axios from 'axios';

export const login = ({email, password}) => {
	return axios.post("https://52.15.178.92/admin/login/", {email, password})
}
